
import { Component, Vue } from "vue-property-decorator";
import { API_ROUTES } from "@/utils/API";
import { SMApp } from "@/store";
import {
  API_TSponsorship_candidates,
  convertSponsorshipCandidatesForTable,
} from "@/models/company_sponsorship_candidates";

@Component({
  components: {
    AppendCandidate: () => import("@/modules/Compliance/Candidates/AppendCandidate.vue"),
    PendingInvitesTable: () => import("@/modules/Compliance/Candidates/PendingInvitesTable.vue"),
    CandidatesTable: () => import("@/modules/Compliance/Candidates/CandidatesTable.vue"),
  },
})
export default class CandidatesBrowse extends Vue {
  loading = false;

  candidates: API_TSponsorship_candidates[] = [];

  get caseId() {
    return Number(this.$route.params.id ?? 0);
  }

  async mounted() {
    await this.getCandidates();

    SMApp.setPageSubTitle("");
  }

  activated() {
    SMApp.setPageSubTitle("");
  }

  async getCandidates() {
    try {
      this.loading = true;

      const { data } = await this.axios.get(API_ROUTES.COMPANY_SPONSORSHIP_CANDIDATES(this.caseId));

      if (!data) return;

      this.candidates = data.map((a: API_TSponsorship_candidates) =>
        convertSponsorshipCandidatesForTable(a)
      );
    } finally {
      this.loading = false;
    }
  }
}
